import apollo from '@/apollo.js'
import gql from 'graphql-tag'

export const createSummaryDisplayField = async (data) => {
  const response = await apollo.mutate(
    {
      mutation: gql(`
      mutation createSummaryDisplayField($caseTypeId: Int!, $fieldSet: String!, $fieldName: String!, $position: Int!) {
        createSummaryDisplayField(caseTypeId: $caseTypeId, fieldSet: $fieldSet, fieldName: $fieldName, position: $position) { id error message lowLevelErrorMessage }
      }`),
      variables: { caseTypeId: data.id, fieldSet: data.fieldset, fieldName: data.fieldName, position: data.position }
    }
  )
  return response.data.createSummaryDisplayField
}

export const updateSummaryDisplayField = async (data) => {
  const response = await apollo.mutate(
    {
      mutation: gql(`
      mutation updateSummaryDisplayField($id: Int!, $fieldSet: String!, $fieldName: String!, $position: Int!) {
        updateSummaryDisplayField(id: $id, fieldSet: $fieldSet, fieldName: $fieldName, position: $position) { error message lowLevelErrorMessage }
      }`),
      variables: { id: data.id, fieldSet: data.fieldset, fieldName: data.fieldName, position: data.position }
    }
  )
  return response.data.updateSummaryDisplayField
}

export const summariseCases = async (caseTypeId) => {
  const response = await apollo.mutate(
    {
      mutation: gql(`
        mutation summariseCases($caseTypeId: Int!) {
          summariseCases(caseTypeId: $caseTypeId) { error message lowLevelErrorMessage }
        }`),
      variables: { caseTypeId: caseTypeId }
    }
  )
  return response.data.summariseCases
}

export const deleteSummaryDisplayField = async (id) => {
  const response = await apollo.mutate(
    {
      mutation: gql(`
      mutation deleteSummaryDisplayField($id: Int!) {
        deleteSummaryDisplayField(id: $id) { error message lowLevelErrorMessage }
      }`),
      variables: { id: id }
    }
  )
  return response.data.deleteSummaryDisplayField
}
